module.exports = __webpack_public_path__ + "img/js.8a755294.png";